import styled from "styled-components";
import Row from "react-bootstrap/Row";

export const StyledWrapperSpeakers = styled.div`
  margin-top: 40px;
  padding: 0px;
  h1 {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
    margin-left: 70px;
    color: #000000;
  }
  hr {
    height: 6px;
    opacity: 1.25;
    background: #e63457;
  }
  .react-multiple-carousel__arrow--right {
    right: calc(0% + 1px);
    top: 106px;
}
.react-multiple-carousel__arrow--left {
  right: calc(0% + 1px);
  top: 106px;
}
`;

export const StyleUlCredits = styled.div`
  font-size: 16px;
  text-align: center;
   li {
    line-height: 40px;
    list-style: none
  }

  @media (max-width: 500px) {
    margin-bottom: 0;
    columns: 1;
    li {
      font-size: 12px;
    }
  
  }
`;

export const StyledNewsletterContact = styled.div`
  margin-top: 0px;
  margin-top: 6px;
  font-size: 12px;
  font-weight: bold;

  button {
    background: white;
    border: 1px solid white;
    padding: 6px;
    padding-left: 9px;
    font-weight: bold;
    width: 55%;
    text-align: left;
    cursor: pointer;
    a {
      color: #000;
    }
    @media (max-width: 1024px) {
      width: 75%;
    }
  }
  span {
    background: #E63457;
    padding: 8px 8px 10px 8px;
  }

  a {
    color: #fff;
  }
`;

export const StyledScroll = styled(Row)`
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #354052; 
  border-radius: 19px;
}
`;


